import React from 'react';
import { Redirect } from 'react-router-dom';
import {
  AppRoutes,
  POST_LOGIN_DESTINATION_KEY,
  POST_LOGIN_WELCOME_PENDING_KEY,
} from '../../constants/AppConstant';
import { getAdminName } from '../../service/CookieManager';
import './style.scss';

const Home: React.FC = () => {
  const [showWelcome] = React.useState(() => {
    return sessionStorage.getItem(POST_LOGIN_WELCOME_PENDING_KEY) === 'true';
  });
  const destination =
    sessionStorage.getItem(POST_LOGIN_DESTINATION_KEY) || AppRoutes.Dashboard;
  const adminName = getAdminName() || 'Admin';
  const firstName = adminName.split(' ')[0];

  React.useEffect(() => {
    sessionStorage.removeItem(POST_LOGIN_WELCOME_PENDING_KEY);
    if (!showWelcome) {
      sessionStorage.removeItem(POST_LOGIN_DESTINATION_KEY);
    }
  }, [showWelcome]);

  if (!showWelcome) {
    return <Redirect to={destination} />;
  }

  return (
    <div className="home-page">
      <div className="home-content">
        <img className="home-icon" src="/logowithname.png" alt="" />
        <p className="home-content__line">Welcome To Your Documitra Account</p>
        <h1 className="home-content__name">{firstName} !</h1>
      </div>
    </div>
  );
};

export default Home;
